import React, { useRef, useState } from "react";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { getBase64 } from "../../helper";

const Uploadcv = ({ getData, getOnSave, nightShift }) => {
  const [error, setError] = useState(false);
  const el = useRef();

  const handleChange = async (e) => {
    const file = e.target.files[0];
    if (file.size > 5e6) {
      setError(true);
      return false;
    }
    const baseFile = await getBase64(file);
    let fileData = file;
    fileData.baseFile = baseFile;
    getOnSave("uploadcv", fileData);
    setError(false);
  };

  return (
    <>
      <section className="uploadCVSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>4. Upload Your Resume</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <form>
                <div className="form-group">
                  <div className="file-upload">
                    <div className="file-select">
                      <div className="file-select-button">Choose File</div>
                      <div className="file-select-name" title={getData.name}>
                        {getData.name ?? "No file chosen..."}
                      </div>
                      <input
                        type="file"
                        name="userfile"
                        ref={el}
                        onChange={handleChange}
                        accept=".doc, .docx, application/pdf"
                      />
                    </div>
                  </div>
                  {error ? (
                    <span className="text-danger">
                      Please upload a file smaller than 2 MB
                    </span>
                  ) : null}
                </div>
                <FormGroup className="checkbox">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={nightShift}
                        inputProps={{ "aria-label": "controlled" }}
                        value={nightShift}
                        onChange={(e) =>
                          getOnSave("nightShift", e.target.checked)
                        }
                      />
                    }
                    label="Interested In Getting 12% Higher Pay In Night Shift/UK Shift?"
                  />
                </FormGroup>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Uploadcv;
